export type SortOrder = 'asc' | 'desc'
export type SortState = { key: string; order: SortOrder } | null

/** none → sortFirst → opposite → none. A different column starts at its sortFirst. */
export function cycleSort(current: SortState, key: string, sortFirst: SortOrder = 'asc'): SortState {
  if (!current || current.key !== key) return { key, order: sortFirst }
  if (current.order === sortFirst) return { key, order: sortFirst === 'asc' ? 'desc' : 'asc' }
  return null
}

/**
 * Unknown key or bad order is ignored. Those params are deleted on `sp`
 * so the request never sends them. Pass a copy if the caller must detect the change.
 */
export function sortFromSearch(sp: URLSearchParams, allowed: ReadonlySet<string>): SortState {
  const key = sp.get('sort')
  const order = sp.get('order')
  const ok = Boolean(key && (order === 'asc' || order === 'desc') && allowed.has(key))
  if (!ok) {
    if (key || order) {
      sp.delete('sort')
      sp.delete('order')
    }
    return null
  }
  return { key: key as string, order: order as SortOrder }
}

export function writeSort(cur: URLSearchParams, sort: SortState) {
  if (!sort) {
    cur.delete('sort')
    cur.delete('order')
    return
  }
  cur.set('sort', sort.key)
  cur.set('order', sort.order)
}
